module.exports = __webpack_public_path__ + "static/icon02-e923a5a47b8e9bf1896f50574888df0e.svg";